import React from "react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import locale from "../locale";
import {
  CO2_KG_PER_ALL_IN_ONE,
  CO2_KG_PER_DESKTOP,
  CO2_KG_PER_MONITOR,
  CO2_KG_PER_NOTEBOOK,
  CO2_KG_PER_PERIPHERAL_DEVICE,
  CO2_KG_PER_SMARTPHONE,
  CO2_KG_PER_TABLET,
} from "../calculationParams";

const useStyles = createUseStyles({
  table: {
    border: "none !important",
    width: "100% !important",
    "&:before": {
      background: "none !important",
    },
  },
  headers: {
    height: "36px !important",
    fontWeight: "700px !important",
    fontSize: "16px !important",
    lineHeight: "20px !important",
    color: "#7C7C7C !important",
    textAlign: "left !important",
    width: "25% !important",
    "& th:last-child": {
      width: "50%",
      textAlign: "right",
    },
  },
  deviceResults: {
    height: "36px !important",
    marginTop: "8px !important",
    marginBottom: "8px !important",
    fontWeight: "400px !important",
    fontSize: "16px !important",
    lineHeight: "20px !important",
    color: "white !important",
    textAlign: "left !important",
    width: "25% !important",
    border: "none !important",
    "& td:last-child": {
      width: "50% !important",
      textAlign: "right !important",
    },
  },
});

const DeviceCategoryRow = ({
  deviceCategoryName,
  deviceAmount,
  deviceFootprintKg,
}) => {
  const classes = useStyles();
  const LL = locale;

  return (
    <tr className={classes.deviceResults}>
      <td>{deviceCategoryName}</td>
      <td>{`${deviceAmount} ${
        deviceAmount.toFixed(0) === "1" ? "unit" : "units"
      }`}</td>
      <td>
        {deviceFootprintKg > 1000
          ? `${(deviceFootprintKg / 1000).toFixed(2)} ${LL.results.unitTonnes}`
          : `${deviceFootprintKg.toFixed(0)} ${LL.results.unitKg}`}
      </td>
    </tr>
  );
};

DeviceCategoryRow.propTypes = {
  deviceCategoryName: PropTypes.string.isRequired,
  deviceAmount: PropTypes.number.isRequired,
  deviceFootprintKg: PropTypes.number.isRequired,
};

const ResultPerDeviceTable = ({
  amountNotebook,
  amountPeripheralDevice,
  amountSmartphone,
  amountTablet,
  amountDesktop,
  amountAllInOne,
  amountMonitor,
}) => {
  const classes = useStyles();
  const LL = locale;

  return (
    <table className={classes.table}>
      <tr className={classes.headers}>
        <th>Device</th>
        <th>Units</th>
        <th>Total (avg.)</th>
      </tr>
      {amountNotebook > 0 && (
        <DeviceCategoryRow
          key={LL.app.deviceCategories.notebook}
          deviceCategoryName={LL.app.deviceCategories.notebook}
          deviceAmount={amountNotebook}
          deviceFootprintKg={amountNotebook * CO2_KG_PER_NOTEBOOK}
        />
      )}
      {amountPeripheralDevice > 0 && (
        <DeviceCategoryRow
          key={LL.app.deviceCategories.peripheralDevice}
          deviceCategoryName={LL.app.deviceCategories.peripheralDevice}
          deviceAmount={amountPeripheralDevice}
          deviceFootprintKg={
            amountPeripheralDevice * CO2_KG_PER_PERIPHERAL_DEVICE
          }
        />
      )}
      {amountSmartphone > 0 && (
        <DeviceCategoryRow
          key={LL.app.deviceCategories.smartphone}
          deviceCategoryName={LL.app.deviceCategories.smartphone}
          deviceAmount={amountSmartphone}
          deviceFootprintKg={amountSmartphone * CO2_KG_PER_SMARTPHONE}
        />
      )}
      {amountTablet > 0 && (
        <DeviceCategoryRow
          key={LL.app.deviceCategories.tablet}
          deviceCategoryName={LL.app.deviceCategories.tablet}
          deviceAmount={amountTablet}
          deviceFootprintKg={amountTablet * CO2_KG_PER_TABLET}
        />
      )}
      {amountDesktop > 0 && (
        <DeviceCategoryRow
          key={LL.app.deviceCategories.desktop}
          deviceCategoryName={LL.app.deviceCategories.desktop}
          deviceAmount={amountDesktop}
          deviceFootprintKg={amountDesktop * CO2_KG_PER_DESKTOP}
        />
      )}
      {amountAllInOne > 0 && (
        <DeviceCategoryRow
          key={LL.app.deviceCategories.allInOne}
          deviceCategoryName={LL.app.deviceCategories.allInOne}
          deviceAmount={amountAllInOne}
          deviceFootprintKg={amountAllInOne * CO2_KG_PER_ALL_IN_ONE}
        />
      )}
      {amountMonitor > 0 && (
        <DeviceCategoryRow
          key={LL.app.deviceCategories.monitor}
          deviceCategoryName={LL.app.deviceCategories.monitor}
          deviceAmount={amountMonitor}
          deviceFootprintKg={amountMonitor * CO2_KG_PER_MONITOR}
        />
      )}
    </table>
  );
};

ResultPerDeviceTable.propTypes = {
  amountNotebook: PropTypes.number.isRequired,
  amountPeripheralDevice: PropTypes.number.isRequired,
  amountSmartphone: PropTypes.number.isRequired,
  amountTablet: PropTypes.number.isRequired,
  amountDesktop: PropTypes.number.isRequired,
  amountAllInOne: PropTypes.number.isRequired,
  amountMonitor: PropTypes.number.isRequired,
};

export default ResultPerDeviceTable;



// WEBPACK FOOTER //
// ./src/components/ResultPerDeviceTable.js